'use strict';

var Backbone = require('backbone'),

  LazyLoadView = Backbone.View.extend({

    initialize: function() {
      this.$el.lazyload({
      //jscs:disable
        skip_invisible: true // jshint ignore:line
      //jscs:enable
      });
    }
  },
  {
    create: function($parent) {
      // Buying options views
      $parent.find('img.lazy').each(function(n, el) {
        new LazyLoadView({
          el: el
        });
      });
    }
  });

module.exports = LazyLoadView;



// WEBPACK FOOTER //
// ./assets/js/components/LazyLoadView.js